import {applyMiddleware, compose, createStore} from 'redux';
import {createLogger} from 'redux-logger';


import * as storeSync from './storeSync';

import config from '../config';

import devToolsComposer from './devToolsComposer';
import rootReducer from './reducer/rootReducer';
import {saveFromStore} from './storeSync';


const isDevelopment = config.environment.isDevelopment;
const composer = isDevelopment ? devToolsComposer : compose;


export default (preloadedState = {}) => {

    const middlewares = [];

    // logging is enabled on all environments for the time being
    if (isDevelopment) {

        const loggerMiddleware = createLogger({
            collapsed: (getState, action, logEntry) => !logEntry.error,
            predicate: (getState, action) => !action.type.includes('/')
        });

        middlewares.push(loggerMiddleware);
    }

    // middleware, store enhancements and finally creating the store object
    const appliedMiddleware = applyMiddleware(...middlewares);
    const storeCreator = composer(appliedMiddleware)(createStore);

    // read fom store
    const populatedState = {
        ...preloadedState,
        ...storeSync.syncToStore()
    };

    const store = storeCreator(rootReducer, populatedState);

    // enable session storage syncing
    store.subscribe(() => storeSync.saveFromStore(store));

    return store;
};
